module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f4769f9bdb7466be6508.eot";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/assets/plugins/fonts/glyphicons-halflings-regular.eot
// module id = ../../../../../src/assets/plugins/fonts/glyphicons-halflings-regular.eot
// module chunks = styles